import { LanguageType } from '@app/types/app';

export const languageOptions: {
  key: LanguageType;
  labelKey: string;
  countryCode: string;
}[] = [
  { key: 'br', labelKey: 'header.languageNames.br', countryCode: 'BR' },
  { key: 'en', labelKey: 'header.languageNames.en', countryCode: 'GB' },
  { key: 'es', labelKey: 'header.languageNames.es', countryCode: 'AR' },
];
